import { Box } from '@coolblue-development/becky';
import { Typography } from '@coolblue-development/freddy';
import EmailTransferIcon from '../../../Icons/EmailTransferIcon';
import { EmailTransfer } from '../../../../../models/Email';

interface TransferredBannerProps {
  transferDetails?: EmailTransfer;
}

const TransferredBanner = ({ transferDetails }: TransferredBannerProps): JSX.Element => (
  <Box sx={{ margin: '16px 0', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
    <Box sx={{ display: 'flex', gap: '8px' }}>
      <EmailTransferIcon />
      <Typography variant="h6" color="subtle">
        Transferred contact
      </Typography>
    </Box>
    {transferDetails && (
      <Typography variant="caption" color="subtle">
        {transferDetails.byAgent
          ? `To ${transferDetails.toQueue} by ${transferDetails.byAgent}`
          : `To ${transferDetails.toQueue}`}
      </Typography>
    )}
  </Box>
);

export default TransferredBanner;
